/* <age-gate> — overlay 18+ mémorisé en localStorage (clé + date d'expiration). */
if (!customElements.get('age-gate')) {
  customElements.define(
    'age-gate',
    class AgeGate extends HTMLElement {
      connectedCallback() {
        this.key = this.dataset.storageKey || 'puff_age_ok';
        this.days = parseInt(this.dataset.rememberDays || '30', 10);
        this.denyUrl = this.dataset.denyUrl || 'https://www.google.com';

        if (this.isVerified()) {
          this.remove();
          return;
        }

        this.hidden = false;
        document.documentElement.classList.add('age-gate-open');

        this.querySelector('[data-age-confirm]').addEventListener('click', () => this.confirm());
        this.querySelector('[data-age-deny]').addEventListener('click', () => this.deny());

        const btn = this.querySelector('[data-age-confirm]');
        if (btn) setTimeout(() => btn.focus(), 50);
      }

      isVerified() {
        try {
          const raw = window.localStorage.getItem(this.key);
          if (!raw) return false;
          const until = parseInt(raw, 10);
          return !Number.isNaN(until) && Date.now() < until;
        } catch (e) {
          return false;
        }
      }

      confirm() {
        try {
          const until = Date.now() + this.days * 24 * 60 * 60 * 1000;
          window.localStorage.setItem(this.key, String(until));
        } catch (e) {
          /* stockage indisponible : la question sera reposée à la prochaine visite */
        }
        document.documentElement.classList.remove('age-gate-open');
        this.remove();
      }

      deny() {
        window.location.href = this.denyUrl;
      }
    }
  );
}
